<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>

    <v-snackbar
      v-model="snackbar.display"
      id="snackbar_message"
      bottom
      center
      autoHeight
      :timeout="snackbar.options.timeout"
      :color="snackbar.options.color"
    >
      {{ snackbar.message }}

      <CSButton
        id="snackbar_message_button"
        color="slate100"
        flat
        :text="translate('BUTTON_REGISTRATIONCONFIRM_SNACKBAR')"
        :onClick="() => (snackbar.display = false)"
        small
      />
    </v-snackbar>
  </v-app>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import { eventBus } from '@/main'

// Set the default layout
const default_layout = 'empty'

export default {
  name: '',
  components: {
    CSButton,
  },
  data() {
    return {
      snackbar: {
        message: '',
        display: false,
        defaultOptions: {
          timeout: 6000,
          color: 'success',
        },
        options: {},
      },
    }
  },
  computed: {
    layout() {
      // get the layout from the router
      return `${this.$route.meta.layout || default_layout}-layout`
    },
  },
  created() {
    eventBus.$on('showSnackbarMessage', (message, options = {}) => {
      this.snackbar.display = true
      this.snackbar.message = message
      this.snackbar.options = Object.assign(
        {},
        this.snackbar.defaultOptions,
        options,
      )
    })
  },
}
</script>
